import React, { createContext, useContext, useMemo } from 'react';

const NATIVE_WEBVIEW_STORAGE_KEY = 'JZ_NATIVE_WEBVIEW';
const NativeWebViewContext = createContext(false);

function normalizeBoolean(value) {
  if (value === true || value === false) return value;
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    return normalized === '1' || normalized === 'true' || normalized === 'yes';
  }
  return false;
}

export function getIsNativeWebView() {
  if (typeof window === 'undefined') return false;

  const globalFlag = normalizeBoolean(window.__JZ_NATIVE_WEBVIEW__);
  if (globalFlag) return true;

  const nativeAppTag = String(window.__JZ_NATIVE_APP__ || '').toLowerCase();
  if (nativeAppTag === 'jz-native') return true;

  if (window.ReactNativeWebView) return true;

  try {
    return normalizeBoolean(window.localStorage.getItem(NATIVE_WEBVIEW_STORAGE_KEY));
  } catch {
    return false;
  }
}

export function NativeWebViewProvider({ children }) {
  const isNativeWebView = useMemo(() => getIsNativeWebView(), []);

  if (typeof window !== 'undefined') {
    window.__JZ_NATIVE_WEBVIEW_CONTEXT__ = isNativeWebView;
  }

  return (
    <NativeWebViewContext.Provider value={isNativeWebView}>
      {children}
    </NativeWebViewContext.Provider>
  );
}

export function useIsNativeWebView() {
  return useContext(NativeWebViewContext);
}

